import { render, staticRenderFns } from "./BankItem.vue?vue&type=template&id=9ecf0928"
import script from "./BankItem.vue?vue&type=script&lang=js"
export * from "./BankItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports